<template lang="pug">
    .settings-dashboard
        .settings-dashboard-wrapper
            settings-page-head

            .dashboard-table-wrapper
                .dashboard-table-items-wrap
                    .dashboard-table.dashboard-table--7-columns
                        .dashboard-table__head
                            .dashboard-table__head-item product
                            .dashboard-table__head-item quantity
                            .dashboard-table__head-item price
                            .dashboard-table__head-item creator
                            .dashboard-table__head-item purchase date
                            .dashboard-table__head-item total
                            .dashboard-table__head-item status
                        template(v-for="order in orders")
                            .dashboard-table__item(v-for="item in order.items.data" :key="item.id")
                                .dashboard-table__item-content.name {{ item.product.data.title }}
                                .dashboard-table__item-content.price {{ item.count }}
                                .dashboard-table__item-content.price {{ item.single_price | currency }}
                                .dashboard-table__item-content.username {{ item.product.data.user ? item.product.data.user.data.name : null }}
                                .dashboard-table__item-content.purchase_date {{ order.created_at.substring(0, 10) }}
                                .dashboard-table__item-content.platform_fee {{ item.total | currency }}
                                .dashboard-table__item-content.status
                                    .dashboard-table__item-status(:class="order.state") {{ order.state }}

                dashboard-table-paging(v-if="pages > 1" :page="page" :pages="pages" @click="load($event.page)")

        .re-loading(v-show="loading")
            static-loader-control

</template>

<script>
const PAGE_SIZE = 10

export default {
    name: 'settings-purchased',

    data() { return {
        orders: [],
        loading: false,
        pages: 1,
        page: 1,
    }},

    async created() {
        await this.load()
    },


    methods: {
        async load(page = 1) {
            try {
                this.loading = true

                const query = {
                    include: 'items.product.user',
                    page_size: PAGE_SIZE,
                    page: page,
                }

                const { data: { data: orders, meta: { pagination } } } = await axios.get('/api/customer/user/order?' + (new URLSearchParams(query).toString()))

                this.page = pagination.current_page
                this.pages = pagination.total_pages

                this.orders = orders
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
